<template>
  <button
    class="nosto-active-value-tag text-heading-2xs"
    type="button"
  >
    <span
      class="nosto-facet__label text-body-2xs"
      v-text="title"
    />
    <span
      v-if="count"
      class="nosto-active-value-tag__count text-body-2xs"
      v-text="`(${count})`"
    />

    <span class="nosto-active-value-tag__close">
      <span
        class="visually-hidden"
        v-text="$string('accessibility.close')"
      />

      <icon-close />
    </span>
  </button>
</template>

<script>

/**
 * Vue: Nosto active value tag (main-collection)
 * -----------------------------------------------------------------------------
 * Tag shown under collection filters with active value.
 *
 * @param {String} choice - Formatted URL param for choice.
 * @param {Object} sortByOptions - Options for sorting.
 *
 */
import IconClose from '~icons/misc/close.svg'

export default {
  name: 'NostoActiveValueTag',

  components: {
    IconClose,
  },

  props: {
    choice: {
      type: String,
      default: '',
    },
    sortByOptions: {
      type: Object,
      default: () => ({}),
    },
    count: {
      type: Number,
      default: 0,
    },
  },
  computed: {

    /**
     * Compute option.
     * @returns {String}
     */
    option() {
      const optionObject = Object.values(this.sortByOptions).find((object) => {
        return object.id === this.value
      })

      if (!optionObject) {
        return false
      }

      return optionObject.label
    },

    /**
     * Compute title for values that include tag content.
     * @returns {String}
     */
    title() {
      const decodedValue = decodeURIComponent(this.value)
      let title = decodedValue

      if (decodedValue.includes(':')) {
        const replaceWith = ` - ${this.$variable('store.currencySymbol')}`
        title = `${this.$variable('store.currencySymbol')}${decodedValue.replace(':', replaceWith)}`
      }

      if (this.option) {
        return this.option
      }

      return title
    },

    /**
     * Compute value.
     * @returns {String}
     */
    value() {
      return this.choice.split('=')[1]
    },
  },
}
</script>

<style lang="scss">
@import './nosto-active-value-tag';
</style>
